import i18n from '@/locale/index'

export default [
  {
    path: '/exclusivePrivilege',
    name: 'exclusivePrivilege',
    component: () => import('../../views/exclusive/index.vue'),
    meta: {
      title: i18n.global.t('exclusive.title')
    }
  },
  {
    path: '/exclusivePrivilege/choose',
    name: 'choose',
    component: () => import('../../views/exclusive/choose.vue'),
    meta: {
      title: i18n.global.t('exclusive.c33')
    }
  },
  {
    path: '/exclusivePrivilege/detail',
    name: 'detail',
    component: () => import('../../views/exclusive/detail.vue'),
    meta: {
      title: i18n.global.t('exclusive.c14')
    }
  },
  {
    path: '/exclusivePrivilege/rule',
    name: 'rule',
    component: () => import('../../views/exclusive/rule.vue'),
    meta: {
      title: i18n.global.t('exclusive.c14')
    }
  }
]
